import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperTime: {
        display: "flex",
        alignItems: "center",
        position: "relative",
        paddingLeft: 16,
        [theme.breakpoints.down("xl")]: {
            justifyContent: "center",
            paddingLeft: 0,
        },
    },
    timeIcon: {
        width: 24,
        height: 24,
        objectFit: "contain",
        marginRight: 8,
        [theme.breakpoints.down("lg")]: {
            justifyContent: "center",
            marginRight: 0,
        },
    },
    timeLabel: {
        fontSize: 20,
        fontWight: 400,
        color: "#F5F5F5CC",
    },
});
